import 'angular:locale/data:fi';
import 'zone.js';(globalThis.$localize ??= {}).locale = "fi";
